import { Action } from '@ngrx/store';
import { IAgentModel } from '../../models/loyalty/IAgent.model';

// @loyaltyDocs: Binding existing agent

// Binding: User registered in Amadeus+Me, need to connect his account to Amadeus Direct account
export const BIND_AGENT = '[BindAgent] Bind exists agent';
export const BIND_AGENT_SUCCESS = '[BindAgent] Bind exists agent Success';
export const BIND_AGENT_ERROR = '[BindAgent] Bind exists agent Error';

// Register: User not registered in Amadeus+Me, need to create account
// and connect his account to Amadeus Direct account
export const REGISTER_AGENT = '[RegisterAgent] Register new agent';
export const REGISTER_AGENT_SUCCESS = '[RegisterAgent] Register new agent Success';
export const REGISTER_AGENT_ERROR = '[RegisterAgent] Register new agent Error';
export const ALREADY_GET_NUMBER = '[RegisterAgent] Already get register number';

// Actions to bind exists agent
export class BindAgent implements Action {
  readonly type = BIND_AGENT;
  constructor(public payload: any) {}
}

export class BindAgentSuccess implements Action {
  readonly type = BIND_AGENT_SUCCESS;
  constructor(public payload: IAgentModel) {}
}

export class BindAgentError implements Action {
  readonly type = BIND_AGENT_ERROR;
  constructor(public payload: any) {}
}

// Actions to register new agent
export class RegisterAgent implements Action {
  readonly type = REGISTER_AGENT;
  constructor() {}
}

export class RegisterAgentSuccess implements Action {
  readonly type = REGISTER_AGENT_SUCCESS;
  constructor(public payload: IAgentModel) {}
}

export class RegisterAgentError implements Action {
  readonly type = REGISTER_AGENT_ERROR;
  constructor(public payload: any) {}
}

export class AlreadyGetNumber implements Action {
  readonly type = ALREADY_GET_NUMBER;
  constructor(public payload: boolean) {}
}

export type AgentActions =
  | BindAgent
  | BindAgentSuccess
  | BindAgentError
  | RegisterAgent
  | RegisterAgentSuccess
  | RegisterAgentError
  | AlreadyGetNumber;
